import clsx from 'clsx'
import type TextButton from 'LuxKit/Button/TextButton'
import { LuxKitModalBehaviourStateContext } from 'LuxKit/Modal/context/LuxKitModalBehaviourContexts'
import { StyledModalFooter } from 'LuxKit/Modal/ModalFooter'
import { stopPropagation } from 'lib/web/eventHandlerUtils'
import type { ComponentProps, PropsWithChildren } from 'react'
import { memo, useContext } from 'react'
import * as React from 'react'
import styled from 'styled-components'

const EvenMoreStyledModalFooter = styled(StyledModalFooter)`
  position: absolute;
  bottom: 0;
  inset-inline: 0;
  min-width: 0;

  &:empty {
    visibility: hidden;
    pointer-events: none;
  }
`

export type ModalFooterOnClickHandler = (e: React.MouseEvent<HTMLButtonElement>, resolve: (result?: any) => void) => void

export interface ModalFooterActionProps extends Omit<ComponentProps<typeof TextButton>, 'onClick' | 'kind' | 'variant' | 'size' | 'fit'> {
  onClick?: ModalFooterOnClickHandler
}

interface Props extends PropsWithChildren {
  ref?: React.RefObject<HTMLElement | null>
}

function OfferComparisonModalFooter({
  children,
  ref,
}: Props) {
  const modalBehaviourState = useContext(LuxKitModalBehaviourStateContext)

  return <EvenMoreStyledModalFooter
    className={clsx({
      'has-shadow': !(modalBehaviourState?.bodyHasReachedEnd ?? true),
    })}
    onClick={stopPropagation}
    ref={ref}
  >
    {children}
  </EvenMoreStyledModalFooter>
}

export default memo(OfferComparisonModalFooter)
